export default __webpack_public_path__ + "static/media/3-banner.e390f846.png";